import 'core-js/stable/array';
import 'core-js/stable/reflect';
import 'zone.js';

import { Buffer } from 'buffer';
import { TextDecoder, TextEncoder } from 'text-encoding';

(window as any).global = window;

if (!window['TextDecoder']) {
  window['TextDecoder'] = TextDecoder;
}

if (!window['TextEncoder']) {
  window['TextEncoder'] = TextEncoder;
}

if (!window['Buffer']) {
  window['Buffer'] = Buffer;
}
